import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const octopusDeploy = defineConnector({
  identifier: "octopusDeploy",
  name: "Octopus Deploy",
  tagLine: "Deployment automation server",
  logo,
  protocol: "http",
  tags: ["engineering"],
  auth: (app) =>
    headerAuth([{ name: "X-Octopus-ApiKey", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Enter your Octopus Deploy instance URL",
      items: [
        {
          kind: "markdown",
          content:
            "Provide the URL of your Octopus Deploy instance (e.g. `https://your-instance.octopus.app`).",
        },
        {
          kind: "baseUrl",
          label: "Instance URL",
          required: true,
          target: { kind: "configuration", field: "instanceUrl" },
          placeholder: "https://your-instance.octopus.app",
        },
      ],
    },
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Octopus Deploy, go to **Profile → My API Keys** and create a new API key.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/api`,
  },
});
